// views/auth/login.js  (FR)
export const login_i18n = {
  panelKicker: "WACHECKIN · 2026",
  panelCta: "Découvrir WACheckin",
  partnersLabel: "Connecté à",
  // Les cartes de la scène du panneau.
  escena: {
    reservas: "Réservations",
    mensajes: "Messages automatiques",
    llaves: "Clés numériques",
    checkin: "Check-in en ligne",
    cobros: "Paiements automatisés",
    autoridades: "Autorités et conformité",
  },

  // Étape 2 : le code reçu par e-mail.
  verify: {
    title: "Consultez votre e-mail",
    titleWhatsapp: "Consultez votre WhatsApp",
    sending: "Envoi en cours…",
    destinoWhatsapp: "Il sera envoyé au",
    destinoCorreo: "Il sera envoyé à",
    intro: "Nous avons envoyé un code à {largo} chiffres à",
    submit: "Se connecter",
    submitting: "Vérification...",
    back: "Utiliser un autre compte",
    resendAsk: "Vous ne l'avez pas reçu ?",
    resend: "Renvoyer le code",
    resendWait: "Renvoyer dans {s} s",
    resendDone: "Nous vous avons envoyé un nouveau code.",
    expires: "Le code expire dans {tiempo}",
    expired: "Le code a expiré. Demandez-en un nouveau.",
    digitAria: "Chiffre {n} sur {total}",
    otroMetodo: "Vous n'avez pas reçu l'e-mail ?",
    porWhatsapp: "Recevez-le sur WhatsApp",
    preferesCorreo: "Vous préférez l'e-mail ?",
    porCorreo: "Recevez-le par e-mail",
    introWhatsapp: "Nous avons envoyé un code à {largo} chiffres par WhatsApp au",
    enviadoWhatsapp: "Nous vous avons envoyé le code sur WhatsApp.",
  },
  langLabel: "Langue",
  panelTitle: "Tous vos logements automatisés par l'IA",
  panelDesc:
    "Check-in, messages, clés, paiements et déclarations aux autorités. Un seul panneau pour tout.",

  bannerAlt: "fond de connexion",
  brandAlt: "WA Checkin",
  footerLogoAlt: "WA Checkin",
  togglePasswordAria: "afficher ou masquer le mot de passe",

  title: "Bon retour !",
  infoTitle: "Si vous avez déjà un compte, connectez-vous avec votre e-mail.",
  infoDesc: "Si vous n'avez pas encore de compte, vous pouvez vous inscrire en bas.",

  emailLabel: "E-mail",
  emailPlaceholder: "Saisissez votre e-mail",

  passwordLabel: "Mot de passe",
  passwordPlaceholder: "Saisissez votre mot de passe",

  forgot: "Mot de passe oublié ?",

  submit: "Se connecter",
  submitting: "Connexion...",

  noAccount: "Vous n'avez pas de compte ?",
  signup: "Créer un compte",

  terms: "Conditions",
  privacy: "Politique de confidentialité",
  copyright: "© 2024–{anio} WA Checkin. Tous droits réservés.",

  resetSuccess: "Nous vous avons envoyé un e-mail pour récupérer votre mot de passe.",

  errors: {
    default: "Échec de la connexion.",
    network: "Erreur de connexion. Réessayez.",
  },

  resetPassword: {
    title: "Récupérer le mot de passe",
    infoTitle: "Nous vous enverrons un lien par e-mail",
    infoDesc:
      "Saisissez votre e-mail et vous recevrez les instructions pour réinitialiser votre mot de passe.",
    labels: { email: "Adresse e-mail" },
    placeholders: { email: "nom@email.com" },
    hints: { email: "Utilisez l'e-mail avec lequel vous vous êtes inscrit." },
    buttons: { send: "Envoyer", sending: "Envoi..." },
    successTitle: "C'est fait !",
    successDesc: "Vérifiez votre boîte de réception (et les indésirables).",
    aria: { close: "fermer" },
    toasts: {
      emailRequired: "Saisissez votre e-mail.",
      sent: "Nous avons envoyé l'e-mail avec les instructions.",
      userNotFound: "Utilisateur non enregistré.",
      networkError: "Erreur de connexion. Réessayez.",
    },
  },
  common: { ok: "Compris", cancel: "Fermer" },
};
